<template>
  <div class="payment-dialog">
    <div class="wrapper">
      <div style="line-height: 30px;">您当前未完成平台认证审核，认证后即可发布岗位、查看学生投递简历！</div>
      <div class="btn-wrap">
        <el-button type="primary" @click="$router.push('/pay')">马上去认证</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.payment-dialog {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 53px);
  background: rgba(0, 0, 0, .5);
  .wrapper {
    width: 300px;
    border-radius: 20px;
    margin: 250px auto;
    background: #fff;
    text-align: center;
    padding: 50px 50px 20px;
    .btn-wrap {
      margin-top: 50px;
      .el-button {
        width: 40%;
      }
    }
  }
}
</style>
